import React from 'react';

// Styles & Assets
import styles from './PatientsSelector.module.css';

// Services
import { getFullName } from '../../../services/getPatientAtribute';

// Context
import PatientsContext from '../../../context/PatientsContext';

// Hooks
import { useState, useContext } from 'react';

// Components
import SonarPatients from '../../PatientsPage/SonarPatients/SonarPatients';
import TablePatients from '../../PatientsPage/TablePatients/TablePatients';
import ToolbarPatientsSelector from '../ToolbarPatientsSelector/ToolbarPatientsSelector';

// Interfaces
import { Patient } from '../../../interfaces/Patient';

// Language
import { useTranslation } from 'react-i18next';


const PatientsSelector: React.FC<{
    patientsSelected: { id: number, name: string }[]
    setPatientsSelected: React.Dispatch<React.SetStateAction<{ id: number, name: string }[]>>,
}> = ({ patientsSelected, setPatientsSelected }) => {

    const { t } = useTranslation();

    const patientsContext = useContext(PatientsContext);

    const [viewSonar, setViewSonar] = useState<boolean>(false);

    const changeViewSonar = (evt: React.ChangeEvent<HTMLInputElement>) =>
        setViewSonar(evt.target.checked);

    const handlePatientClick = (id: number) => {
        if (patientsSelected.some(patient => patient.id === id)) { // patient already selected
            setPatientsSelected(patients => {
                return patients.filter(patient => patient.id !== id);
            });
        }
        else { // patient not selected
            const patient = patientsContext.patients.find(patient => patient.id === id);
            setPatientsSelected(patients => {
                return [
                    ...patients,
                    { id, name: getFullName(patient) },
                ];
            });
        }
    };

    const setColor = (patient: Patient) => { // default set color row
        if (patientsSelected.some(patientSelected => patientSelected.id === (patient as Patient).id)) return ('var(--highlighted-row)');
        const color = '#fff'; //patient.cases?.[0]?.follow_ups?.find(pfu => pfu.end_date === null)?.profile?.status_color;
        return color;// !== undefined ? '#' + color : '#fff';
    };

    return (
        <div className={styles.patientSelectorContainer}>
            <div className={styles.tableContainer}>
                <ToolbarPatientsSelector viewSonar={viewSonar} changeViewSonar={changeViewSonar} />
                {viewSonar ?
                    <SonarPatients handlePatientClick={handlePatientClick} />
                    :
                    <TablePatients
                        handlePatientClick={handlePatientClick}
                        setColorRow={setColor}
                        filterColumnsIDs={[21]}
                    />
                }
            </div>
            <div className={styles.selectedPatientsContainer}>
                <p className={styles.patientsLabel}>{t('selected_patients')}:</p>
                <div className={styles.selectedPatients}>
                    {patientsSelected.length > 0 ?
                        patientsSelected.map(patient =>
                            <p className={styles.selectedPatient} key={patient.id}>{patient.name}</p>)
                        :
                        <p className={styles.notSelected}>{t('no_patient_selected')}</p>
                    }
                </div>
            </div>
        </div>
    );
};

export default PatientsSelector;